/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Quick_Stock_InInputs */

const vi_warehouse_quick_stock_in = /** @type {(inputs: Warehouse_Quick_Stock_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét nhập nhanh`)
};

/**

* @param {Warehouse_Quick_Stock_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_quick_stock_in = /** @type {((inputs?: Warehouse_Quick_Stock_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Quick_Stock_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_quick_stock_in(inputs)
});